import React, { useRef, useEffect } from "react";
import block from "bem-css-modules";
import Player from "@vimeo/player";
import styles from "./VideoElement.module.scss";

interface VideoProps {
  vimeoId: number;
}

const VideoElement: React.FC<VideoProps> = ({ vimeoId }) => {
  const playerRef = useRef<HTMLDivElement>(null);
  const b = block(styles);

  useEffect(() => {
    if (playerRef.current && vimeoId) {
      const player = new Player(playerRef.current, {
        id: vimeoId,
        width: 640,
        title: false,
        byline: false,
        portrait: false,
        dnt: true,
      });

      return () => {
        player.destroy();
      };
    }
  }, [vimeoId]);

  return (
    <div className={`fc-video-element ${b()}`}>
      <div ref={playerRef} className={b('player-wrapper')}></div>
    </div>
  );
};

export default VideoElement;
